module.exports = __webpack_public_path__ + "static/media/hassan.468812c7.png";